import React, { ChangeEvent } from "react";
import {
  FormControl,
  FormHelperText,
  Grid,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { ICredentialsPickitProps } from "../../interfaces/configuration";

const CredentialsPickit = ({
  values,
  setValues,
  errors,
}: ICredentialsPickitProps) => {
  const showInputErrors = (inputErrors: string[]) =>
    inputErrors.map((message: string) => (
      <FormHelperText className="color-error" key={message}>
        {message}
      </FormHelperText>
    ));
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <FormControl size="small" fullWidth>
          <Typography className="f-s-14 m-b-10">Token</Typography>
          <OutlinedInput
            placeholder={"Ingresar token"}
            value={values.token}
            error={errors.token?.length > 0}
            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
              setValues({ ...values, token: value.trim() })
            }
            className="f-s-14"
            autoFocus
          />
          {errors.token?.length > 0 && showInputErrors(errors.token)}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl size="small" fullWidth>
          <Typography className="f-s-14 m-b-10">API Key</Typography>
          <OutlinedInput
            placeholder={"Ingresar API Key"}
            value={values.apikey}
            error={errors.apikey?.length > 0}
            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
              setValues({ ...values, apikey: value.trim() })
            }
            className="f-s-14"
          />
          {errors.apikey?.length > 0 && showInputErrors(errors.apikey)}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CredentialsPickit;
